exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#swal-input3{display:inline-block}.swal2-input{display:initial;width:400px;height:40px;margin:10px}", ""]);

// exports
